const useUpdatedStepsFeilds = ({ stepsConfig, poolMembers }) => {
  return stepsConfig.map((field) => {
    if (field.name === "stepOwner" && Array.isArray(poolMembers)) {
      return {
        ...field,
        options: poolMembers.map((member) => member.user_first_name),
        values: poolMembers.map((member) => member.user_id),
      };
    }

    return field;
  });
};

export default useUpdatedStepsFeilds;
